import React, { useCallback } from "react";

import Modal from "components/ui/modal/Modal";
import { useFindIntegrationProvider } from "lib/hooks/api/integrations/useFindIntegrationProvider";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { FeatureType } from "../paywallUtils";
import { StrategyPaywallContent } from "./StrategyPaywallContent";

type Props = {
  featureType: FeatureType;
  contextSource?: string;
  isOpen: boolean;
  closeModal: () => void;
  trackingData?: EventData;
};
function StrategyPaywallModal({
  featureType,
  isOpen,
  contextSource,
  closeModal,
  trackingData,
}: Props) {
  const { logEvent } = useTracking();
  const { data: providerType } = useFindIntegrationProvider();

  const trackModalOpen = useCallback(
    (trackingEvent: EventNames) => {
      logEvent(trackingEvent, {
        "Context source": contextSource,
        "Data type": featureType,
        "Connected provider": providerType,
        ...trackingData,
      });
    },
    [contextSource, featureType, logEvent, providerType, trackingData],
  );

  return (
    <Modal
      isOpen={isOpen}
      onOpen={() => trackModalOpen(EventNames.paywallModalOpened)}
      onClose={() => trackModalOpen(EventNames.paywallModalDismissed)}
      modalClose={closeModal}
      maxWidth="1200px"
    >
      <StrategyPaywallContent
        featureType={featureType}
        trackingData={trackingData}
        contextSource={contextSource}
      />
    </Modal>
  );
}

export default StrategyPaywallModal;
